var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2915 5.36108H9.2915V9.36108H5.2915V11.3611H9.2915V15.3611H11.2915V11.3611H15.2915V9.36108H11.2915V5.36108ZM10.2915 0.361084C4.7715 0.361084 0.291504 4.84108 0.291504 10.3611C0.291504 15.8811 4.7715 20.3611 10.2915 20.3611C15.8115 20.3611 20.2915 15.8811 20.2915 10.3611C20.2915 4.84108 15.8115 0.361084 10.2915 0.361084ZM10.2915 18.3611C5.8815 18.3611 2.2915 14.7711 2.2915 10.3611C2.2915 5.95108 5.8815 2.36108 10.2915 2.36108C14.7015 2.36108 18.2915 5.95108 18.2915 10.3611C18.2915 14.7711 14.7015 18.3611 10.2915 18.3611Z",
    fill: "#2278FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.6082a815ef34c84c71f0d8893741d88c.svg";
export { ForwardRef as ReactComponent };